import { Component, ViewChild } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  Content
} from "ionic-angular";
import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";
import { duration } from "moment";

@IonicPage()
@Component({
  selector: "page-comunicacion",
  templateUrl: "comunicacion.html"
})
export class ComunicacionPage {
  @ViewChild(Content) content: Content;

  data: any = {};

  mensaje: any = {};
  respuesta = "";
  hilo = [];
  loading: any;
  tipossolicitud = this.global.CONFIGURA["tipos_solicitud"];
  estadossolicitud = this.global.CONFIGURA["estados_solicitud"];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public conector: ConectorProvider,
    public global: GlobalProvider,
    public loadingController: LoadingController
  ) {
    this.data = {
      background: "assets/images/background/39.jpg"
    };

    this.mensaje = this.navParams.data["mensaje"];
    this.hilo = this.mensaje.hilo.reverse();
  }

  ionViewWillEnter() {
    this.content.scrollToBottom(0);
    console.log("willenter");
  }

  enviarRespuesta() {
    if (this.respuesta !== "") {
      this.presentLoading();
      this.conector
        .responderMensaje(this.mensaje.id, this.respuesta)
        .subscribe(resp => {
          this.mensaje = resp["mensaje"];
          this.hilo = this.mensaje.hilo.reverse();
          this.respuesta = "";
          this.loading.dismiss();
          this.conector.presentToast("Respuesta enviada", 1500, "middle");
        });
    }
  }

  async presentLoading() {
    this.loading = this.loadingController.create({
      content: "Enviando...",
      duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/comunicacion/comunicacion.ts